export const Cart = (prevCart, increment, inventory, brand_token,model_token,color_name) => {
  // If empty cart or same color, proceed normally
  if (prevCart.length === 0 || prevCart[0].color_name === color_name) {
      const itemIndex = prevCart.findIndex(item => item.token === inventory.token);
      
      if (itemIndex !== -1) {
          const updatedCart = [...prevCart];
          updatedCart[itemIndex].quantity = increment
              ? updatedCart[itemIndex].quantity + 1
              : Math.max(updatedCart[itemIndex].quantity - 1, 0);
          return updatedCart.filter(item => item.quantity > 0);
      } else {
          return [...prevCart, {...inventory, quantity: 1,brand_token,model_token,color_name}];
      }
  }
  // If color changed, return empty array (cart will be cleared by the useEffect)
  return [];
}

export const generatePickupDates = () => {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const months = [
    "January", "February", "March", "April", "May", "June", 
    "July", "August", "September", "October", "November", "December"
  ];
  
  let dates = [];
  
  for (let i = 0; i < 6; i++) {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + i);
    
    dates.push({
      date: currentDate.getDate(),
      day: days[currentDate.getDay()],
      month: months[currentDate.getMonth()], 
      monthIndex: currentDate.getMonth() + 1, 
      year: currentDate.getFullYear(),
      dateString: `${currentDate.getDate()}-${currentDate.getMonth()+1}-${currentDate.getFullYear()}` 
    });
  }
  
  return dates;
};


export const generateRandomId = (length = 10) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};


export function groupProductsByPhone(orderData) {
  const productsArray = JSON.parse(orderData.products);
  const groupedProducts = {};

  // Group products by phone
  productsArray.forEach(product => {
    if (!groupedProducts[product.phone]) {
      groupedProducts[product.phone] = {
        phone: product.phone,
        color: product.color_name,
        url: product.phone_url,
        products: [],
      };
    }

    groupedProducts[product.phone].products.push({
      token: product.token,
      product_name: product.product,
      quantity: product.quantity,
      price: product.payable_price,
    });
  });

  // Convert to array format
  const result = Object.values(groupedProducts);

  return result
}